export const PORTAL_PASSWORD = "Genpact@2026";

export const portalUsers = [
  { username: "amol.patil", name: "Amol Patil" },
  { username: "kiran.chadlavada", name: "Kiran Chadlavada" },
  { username: "m.srinivasan", name: "M Srinivasan" },
  { username: "edmond.schneider", name: "Edmond Schneider" },
  { username: "abhishek.malhotra", name: "Abhishek Malhotra" },
  { username: "tin.huynh", name: "Tin Huynh" },
  { username: "sanjeeb.digol", name: "Sanjeeb Digol" },
  { username: "shatakshi.upadhyaya", name: "Shatakshi Upadhyaya" },
  { username: "davis.nayak", name: "Davis Nayak" },
  { username: "smruti.nanda.goswami", name: "Smruti Ranjan Nanda Goswami" },
  { username: "gayatri.mohanty", name: "Gayatri Mohanty" },
  { username: "sushree.panigrahi", name: "Sushree Panigrahi" },
  { username: "rama.piratla", name: "Rama Piratla" },
  { username: "tom.richer", name: "Tom Richer" },
].map((user) => ({
  ...user,
  password: PORTAL_PASSWORD,
}));

export const findPortalUser = (username, password) =>
  portalUsers.find(
    (user) =>
      user.username.toLowerCase() === String(username || "").trim().toLowerCase() &&
      user.password === password
  );
